import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@convex/_generated/dataModel";
import { PlayerGameLogAudit } from "@/features/admin/players/components/PlayerGameLogAudit";
import { useAdminPlayerGameLog } from "@/features/admin/players/hooks/useAdminPlayerGameLog";
import { AdminShell } from "@/features/admin/shell/AdminShell";
import { useT } from "@/shared/i18n";
import { EmptyState } from "@/shared/ui/EmptyState";
import { Skeleton } from "@/shared/ui/Skeleton";

export const Route = createFileRoute("/_adminGuarded/admin/players/$playerId")({
  component: AdminPlayerGameLogPage,
});

function AdminPlayerGameLogPage() {
  const t = useT();
  const { playerId } = Route.useParams();
  const data = useAdminPlayerGameLog(playerId as Id<"players">);

  const breadcrumbs =
    data === undefined
      ? [{ label: t("admin.players.title"), to: "/admin/players" }, { label: t("admin.players.loading") }]
      : [
          { label: t("admin.players.title"), to: "/admin/players" },
          { label: data?.player.fullName ?? t("admin.players.missingPlayer") },
        ];

  return (
    <AdminShell breadcrumbs={breadcrumbs}>
      {data === undefined ? (
        <div className="flex flex-col gap-4">
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-64 w-full" />
          <Skeleton className="h-64 w-full" />
        </div>
      ) : data === null ? (
        <EmptyState
          title={t("admin.players.notFoundTitle")}
          description={t("admin.players.notFoundDescription")}
        />
      ) : (
        <PlayerGameLogAudit data={data} />
      )}
    </AdminShell>
  );
}
